// /admin/infraestructura/alertas
// Gestión de destinatarios + historial de alertas enviadas por el cron alertar-sistema-roto.

import { useEffect, useState } from 'react'
import AdminLayout from '../../components/AdminLayout'
import { supabase } from '../../lib/supabase'

export default function AlertasSistema() {
  const [destinatarios, setDestinatarios] = useState([])
  const [logs, setLogs] = useState([])
  const [estado, setEstado] = useState(null)
  const [loading, setLoading] = useState(true)
  const [nuevo, setNuevo] = useState({ nombre: '', telefono_e164: '+598', alertar_warn: true, alertar_error: true, alertar_recuperacion: true, activo: true })
  const [probando, setProbando] = useState(false)

  useEffect(() => { cargar() }, [])
  async function cargar() {
    setLoading(true)
    const [d, l, e] = await Promise.all([
      supabase.from('sistema_alertas_destinatarios').select('*').order('created_at'),
      supabase.from('sistema_alertas_log').select('*').order('fecha', { ascending: false }).limit(50),
      supabase.from('sistema_alertas_estado').select('*').eq('id', 1).single(),
    ])
    setDestinatarios(d.data || [])
    setLogs(l.data || [])
    setEstado(e.data)
    setLoading(false)
  }

  async function agregar(e) {
    e.preventDefault()
    if (!nuevo.telefono_e164.match(/^\+\d{10,15}$/)) { alert('Teléfono debe ser formato E.164 (+59899123456)'); return }
    try {
      const { error } = await supabase.from('sistema_alertas_destinatarios').insert(nuevo)
      if (error) throw error
      setNuevo({ nombre: '', telefono_e164: '+598', alertar_warn: true, alertar_error: true, alertar_recuperacion: true, activo: true })
      cargar()
    } catch (err) { alert('Error: ' + err.message) }
  }

  async function borrar(id) {
    if (!confirm('¿Borrar destinatario?')) return
    await supabase.from('sistema_alertas_destinatarios').delete().eq('id', id)
    cargar()
  }

  async function toggleActivo(d) {
    await supabase.from('sistema_alertas_destinatarios').update({ activo: !d.activo }).eq('id', d.id)
    cargar()
  }

  async function probarAhora() {
    setProbando(true)
    try {
      const r = await fetch('https://xsviveqhkppmhncodhuv.supabase.co/functions/v1/alertar-sistema-roto', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}'
      })
      const data = await r.json()
      alert(`Corrida manual:\nEstado: ${data.estado_nuevo}\nEvento: ${data.evento || '(sin cambio)'}\nDestinatarios avisados: ${data.destinatarios_avisados || 0}`)
      cargar()
    } catch (e) { alert('Error: ' + e.message) }
    finally { setProbando(false) }
  }

  async function dispararPrueba() {
    // Marca estado como 'error' fake para que la próxima corrida envíe alerta de "recuperación"
    if (!confirm('Esto va a forzar un envío de WA de prueba a todos los destinatarios activos. ¿Continuar?')) return
    setProbando(true)
    try {
      await supabase.from('sistema_alertas_estado').update({ ultimo_estado: 'error', ultimo_cambio_at: new Date().toISOString() }).eq('id', 1)
      await fetch('https://xsviveqhkppmhncodhuv.supabase.co/functions/v1/alertar-sistema-roto', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}'
      })
      alert('✓ Si todo OK, los destinatarios recibieron WA de "sistemas recuperados".')
      cargar()
    } catch (e) { alert('Error: ' + e.message) }
    finally { setProbando(false) }
  }

  const dotColor = (estado?.ultimo_estado === 'error' ? '#DC2626' : estado?.ultimo_estado === 'warn' ? '#F59E0B' : '#16A34A')

  return (
    <AdminLayout>
      <div className="al-page">
        <div className="al-head">
          <h1>Alertas del sistema</h1>
          <p>Cuando algo se cae (o se recupera), te llega WhatsApp. El cron corre cada 5 minutos.</p>
        </div>

        <section className="al-estado-card">
          <div className="al-estado-row">
            <span className="al-estado-dot" style={{ background: dotColor }} />
            <div>
              <div className="al-estado-label">Estado actual: <b>{estado?.ultimo_estado || '—'}</b></div>
              <div className="al-estado-sub">
                Última corrida: {estado?.ultima_corrida_at ? new Date(estado.ultima_corrida_at).toLocaleString('es-UY') : '—'}
                {' · '}
                Cambió por última vez: {estado?.ultimo_cambio_at ? new Date(estado.ultimo_cambio_at).toLocaleString('es-UY') : '—'}
              </div>
            </div>
            <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
              <button className="al-btn-ghost" onClick={probarAhora} disabled={probando}>{probando ? '…' : '🔄 Correr ahora'}</button>
              {destinatarios.some(d => d.activo) && (
                <button className="al-btn-test" onClick={dispararPrueba} disabled={probando}>🧪 Probar envío WA</button>
              )}
            </div>
          </div>
        </section>

        <section className="al-card">
          <h2>Destinatarios</h2>
          <p className="al-card-sub">Números que reciben WhatsApp cuando hay cambio de estado. Formato E.164 (+59899123456).</p>
          {loading ? <div className="al-loading">Cargando…</div> :
           destinatarios.length === 0 ? (
            <div className="al-empty">Sin destinatarios. Agregá uno abajo para empezar a recibir alertas.</div>
          ) : (
            <table className="al-tabla">
              <thead><tr><th>Nombre</th><th>Teléfono</th><th>Warn</th><th>Error</th><th>Recuperación</th><th>Activo</th><th></th></tr></thead>
              <tbody>
                {destinatarios.map(d => (
                  <tr key={d.id} style={{ opacity: d.activo ? 1 : 0.5 }}>
                    <td><b>{d.nombre}</b></td>
                    <td><code>{d.telefono_e164}</code></td>
                    <td>{d.alertar_warn ? '✓' : '—'}</td>
                    <td>{d.alertar_error ? '✓' : '—'}</td>
                    <td>{d.alertar_recuperacion ? '✓' : '—'}</td>
                    <td><button className="al-btn-mini" onClick={() => toggleActivo(d)}>{d.activo ? 'Pausar' : 'Activar'}</button></td>
                    <td><button className="al-btn-mini al-btn-danger" onClick={() => borrar(d.id)}>×</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          <form onSubmit={agregar} className="al-form">
            <h3>+ Agregar destinatario</h3>
            <div className="al-form-row">
              <label><span>Nombre</span><input type="text" value={nuevo.nombre} onChange={e => setNuevo({ ...nuevo, nombre: e.target.value })} required placeholder="Nico" /></label>
              <label><span>Teléfono (E.164)</span><input type="tel" value={nuevo.telefono_e164} onChange={e => setNuevo({ ...nuevo, telefono_e164: e.target.value })} required pattern="^\+\d{10,15}$" placeholder="+59899123456" /></label>
              <label className="al-checks">
                <span style={{ display: 'block', marginBottom: 4 }}>Notificar</span>
                <label className="al-cb"><input type="checkbox" checked={nuevo.alertar_warn} onChange={e => setNuevo({ ...nuevo, alertar_warn: e.target.checked })} /> Warn</label>
                <label className="al-cb"><input type="checkbox" checked={nuevo.alertar_error} onChange={e => setNuevo({ ...nuevo, alertar_error: e.target.checked })} /> Error</label>
                <label className="al-cb"><input type="checkbox" checked={nuevo.alertar_recuperacion} onChange={e => setNuevo({ ...nuevo, alertar_recuperacion: e.target.checked })} /> Recuperación</label>
              </label>
              <button type="submit" className="al-btn-primary">Agregar</button>
            </div>
          </form>
        </section>

        <section className="al-card">
          <h2>Historial de alertas enviadas</h2>
          <p className="al-card-sub">Últimas 50 alertas (que dispararon WA). Los chequeos sin cambio no aparecen acá.</p>
          {logs.length === 0 ? (
            <div className="al-empty">Sin alertas registradas. (¡Buena señal!)</div>
          ) : (
            <table className="al-tabla">
              <thead><tr><th>Fecha</th><th>Evento</th><th>Cambio</th><th>Avisados</th><th>Resultado WA</th></tr></thead>
              <tbody>
                {logs.map(l => (
                  <tr key={l.id}>
                    <td style={{ fontSize: 11 }}>{new Date(l.fecha).toLocaleString('es-UY')}</td>
                    <td>{l.evento === 'caida' ? '🔴 caída' : l.evento === 'recuperacion' ? '✅ recuperación' : '⏰ recordatorio'}</td>
                    <td><code>{l.estado_anterior}</code> → <code>{l.estado_nuevo}</code></td>
                    <td>{l.destinatarios_count}</td>
                    <td style={{ fontSize: 11 }}>
                      {(l.whatsapp_resultado || []).map((r, i) => (
                        <div key={i}>{r.ok ? '✓' : '✗'} {r.destinatario} ({r.status})</div>
                      ))}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </section>

        <section className="al-card al-info-card">
          <h2>📖 Cómo funciona</h2>
          <ul>
            <li><b>Cada 5 minutos</b> (pg_cron <code>alertador-sistema-cada-5min</code>) chequea limpack.uy, tienda.limpack.uy, panel.limpack.uy y Supabase API.</li>
            <li><b>Cambio ok → caída:</b> WA inmediato a destinatarios con "alertar_error" activado.</li>
            <li><b>Cambio caída → ok:</b> WA de "recuperado".</li>
            <li><b>Sigue caído por más de 60 min:</b> WA recordatorio.</li>
            <li>Las alertas internas pueden fallar si Supabase mismo se cae. Por eso recomiendo <b>combinar</b> con un monitoreo externo (Better Stack o UptimeRobot, app móvil propia, gratis hasta 10 monitores).</li>
          </ul>
        </section>

      </div>
      <style>{CSS}</style>
    </AdminLayout>
  )
}

const CSS = `
.al-page { padding: 16px 20px 32px; max-width: 1200px; margin: 0 auto; font-family: Inter, system-ui, sans-serif; color: #1A3461 }
.al-head h1 { font-size: 26px; font-weight: 900; margin: 0 0 4px; letter-spacing: -.02em }
.al-head p { font-size: 13px; color: #64748b; margin: 0 0 18px }
.al-card { background: #fff; border: 1px solid #e2e8f0; border-radius: 12px; padding: 18px 22px; margin-bottom: 14px }
.al-card h2 { margin: 0 0 4px; font-size: 16px; font-weight: 800 }
.al-card-sub { font-size: 12.5px; color: #64748b; margin: 0 0 14px }
.al-estado-card { background: #fff; border: 1px solid #e2e8f0; border-radius: 12px; padding: 16px 22px; margin-bottom: 14px }
.al-estado-row { display: flex; align-items: center; gap: 14px }
.al-estado-dot { width: 14px; height: 14px; border-radius: 50%; box-shadow: 0 0 12px currentColor }
.al-estado-label { font-size: 15px; font-weight: 700; color: #1A3461 }
.al-estado-label b { text-transform: uppercase; letter-spacing: .03em }
.al-estado-sub { font-size: 11.5px; color: #64748b }
.al-tabla { width: 100%; border-collapse: collapse; font-size: 13px }
.al-tabla th { text-align: left; padding: 8px 10px; background: #f8fafc; font-size: 11px; color: #64748b; text-transform: uppercase; font-weight: 800; letter-spacing: .04em; border-bottom: 1px solid #e2e8f0 }
.al-tabla td { padding: 8px 10px; border-bottom: 1px solid #f1f5f9 }
.al-tabla code { background: #e0e7ff; color: #3730a3; padding: 1px 6px; border-radius: 4px; font-size: 11.5px }
.al-form { margin-top: 16px; padding-top: 14px; border-top: 1px solid #e2e8f0 }
.al-form h3 { font-size: 13px; font-weight: 800; color: #475569; margin: 0 0 8px; text-transform: uppercase; letter-spacing: .04em }
.al-form-row { display: grid; grid-template-columns: 1fr 1fr 2fr auto; gap: 10px; align-items: end }
.al-form label { display: flex; flex-direction: column; gap: 4px }
.al-form label span { font-size: 11.5px; font-weight: 700; color: #475569 }
.al-form input { padding: 8px 10px; border: 1px solid #cbd5e1; border-radius: 7px; font-size: 13px; font-family: inherit }
.al-checks { display: flex; gap: 12px; align-items: flex-start; flex-direction: column !important }
.al-cb { font-size: 12px; color: #475569; display: flex; gap: 4px; align-items: center; font-weight: 600 }
.al-loading, .al-empty { padding: 22px; text-align: center; color: #94a3b8 }
.al-btn-primary { background: #1A3461; color: #fff; border: 0; padding: 9px 18px; border-radius: 8px; font-size: 13px; font-weight: 800; cursor: pointer; font-family: inherit }
.al-btn-ghost { background: transparent; border: 1px solid #cbd5e1; color: #475569; padding: 7px 12px; border-radius: 7px; font-size: 12px; font-weight: 700; cursor: pointer; font-family: inherit }
.al-btn-test { background: #FEF3C7; border: 1px solid #F59E0B; color: #78350F; padding: 7px 12px; border-radius: 7px; font-size: 12px; font-weight: 800; cursor: pointer; font-family: inherit }
.al-btn-mini { background: transparent; border: 1px solid #cbd5e1; color: #475569; padding: 3px 8px; border-radius: 5px; font-size: 11px; font-weight: 700; cursor: pointer; font-family: inherit }
.al-btn-danger { color: #DC2626; border-color: #FEE2E2 }
.al-info-card { background: #EFF6FF; border-color: #BFDBFE; color: #1E3A8A; font-size: 13px }
.al-info-card h2 { color: #1E3A8A }
.al-info-card ul { padding-left: 20px; line-height: 1.6 }
.al-info-card b { color: #1E40AF }
.al-info-card code { background: rgba(30,64,175,.1); color: #1E3A8A; padding: 1px 6px; border-radius: 4px; font-size: 12px }
`
